// @flow
import axios from 'axios';

export const createMessage = message => axios.post('/api/control-room/messages/', message.toJSON());
